var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from "redux";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
import { ALERTS_OVERVIEW, } from "@redux/interfaces/Reports/iAccountOverview";
import commonOnePlatFormReducer, { CommonOnePlatFormInitState, } from "@redux/reducers/common/commonReducer";
var initAlertOverView = {
    alertsOverview: {
        ASM: [],
        GSM: [],
        FNO: [],
        Ageing: [],
    },
};
var AlertsOverviewReducer = function (state, action) {
    if (state === void 0) { state = initAlertOverView; }
    switch (action.type) {
        case ALERTS_OVERVIEW:
            return __assign(__assign({}, state), { alertsOverview: action.payload.alertsOverview });
        default:
            return __assign({}, state);
    }
};
export default combineReducers({
    reducersData: AlertsOverviewReducer,
    commonData: function (state, action) {
        if (state === void 0) { state = new CommonOnePlatFormInitState(); }
        return commonOnePlatFormReducer(state, action, ERevampReportReducers.AccountOverviewAlertsOverview);
    },
});
